import React from "react";
import RouteSlide1 from "../Assets/Slide3/RouteSlide1.png";
import RouteSlide2 from "../Assets/Slide3/RouteSlide2.png";

const RouteMap = () => {
    
    return (
        <div style={{ padding: "0.5% 4%" }} className="mt-0">
            <h1 className="text-black font-Poly text-2xl text-center text-[#000] font-semibold pt-5"><span className="text-[#005E8A]">OUR </span> ROUTE MAP</h1>

            <hr className="section-divider" style={{ border: "1px solid #D3D3D3", marginLeft: "44.8%", marginRight: "45%" }} />

            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "2%" }}>
                <img src={RouteSlide1} className="img-fluid" alt="Route 1" style={{ maxWidth: "50%"}} />
                <img src={RouteSlide2} className="img-fluid" alt="Route 2" style={{ maxWidth: "50%" }} />
            </div>
            <a href="https://www.google.com/maps?ll=16.440762,80.884104&z=16&t=m&hl=en-US&gl=US&mapclient=embed&cid=12556261595146109836">
            <div style={{ marginTop: "2%" }}>
               
            
                {/* Embed Google Map for the Sri Jyothi Polytechnic College */}
                <iframe
                    src="https://www.google.co.in/maps?q=Sri+Jyothi+Polytechnic+College,+KALAVAPAMULA-521164,+Vuyyuru+Mandal,+Krishna+Dist.,+Andhra+Pradesh&output=embed"
                    width="94%"
                    height="400"
                    frameBorder="0"
                    style={{ border: '3px Solid #727272', borderRadius: "25px", marginLeft: "2%", }}
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex="0"

                ></iframe>
                  
            </div>
            </a>
        </div>
    );
};

export default RouteMap;
